import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { auditTime, distinctUntilChanged } from "rxjs/operators";
import * as fromApp from "../../../../store/app.reducer";
import * as _ from "lodash";
import * as CheckboxPromotionsActions from "../store/checkbox-promotions.actions";
import { ToastController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import {
  applyCustomDiscountPresetValue,
  changeCustomDiscountPromotionType,
  CUSTOM_DISCOUNT_FIXED_MIN,
  CUSTOM_DISCOUNT_PERCENT_MAX,
  CUSTOM_DISCOUNT_PERCENT_MIN,
  CUSTOM_DISCOUNT_PERCENT_PRESETS,
  getFixedCustomDiscountMaxValue,
  initializeCustomDiscountPromotion,
  normalizeCheckboxPromotions,
  persistCheckboxPromotions,
  stepCustomDiscountPromotionValue,
} from "../checkbox-promotions.helpers";

@Component({
  selector: "app-checkbox-promotions-pickup-only",
  templateUrl: "./checkbox-promotions-pickup-only.component.html",
  styleUrls: ["./checkbox-promotions-pickup-only.component.scss"],
})
export class CheckboxPromotionsPickupOnlyComponent
  implements OnInit, OnDestroy
{
  public checkboxPromotions: any;
  public finalPriceLoading: boolean;
  public fixedDiscountMaxValue: number;
  public subtotal: number;
  public noOnlinePayNoPickupPromos: any;
  public percentMaxValue = CUSTOM_DISCOUNT_PERCENT_MAX;
  public percentMinValue = CUSTOM_DISCOUNT_PERCENT_MIN;
  public percentPresetValues = CUSTOM_DISCOUNT_PERCENT_PRESETS;
  public fixedMinValue = CUSTOM_DISCOUNT_FIXED_MIN;
  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store<fromApp.AppState>,
    private toastController: ToastController,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.store.select("disableFinalPrice").subscribe((state) => {
        if (
          state &&
          !_.isEqual(state.disableFinalPrice, this.finalPriceLoading)
        ) {
          this.finalPriceLoading = _.cloneDeep(state.disableFinalPrice);
        }
      })
    );

    this.subscriptions.push(
      this.store
        .select("checkboxPromotions")
        .pipe(distinctUntilChanged())

        .subscribe((state) => {
          const normalizedCheckboxPromotions = normalizeCheckboxPromotions(
            state?.checkboxPromotions
          );

          if (
            state &&
            state.checkboxPromotions &&
            !_.isEqual(this.checkboxPromotions, normalizedCheckboxPromotions)
          ) {
            this.checkboxPromotions = normalizedCheckboxPromotions;

            this.noOnlinePayNoPickupPromos = _.filter(
              this.checkboxPromotions,
              (promos) => {
                return !promos.onlinePaymentOnly && !promos.pickupOnly;
              }
            );
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("cartPrices")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            state.cartPrices &&
            !_.isEqual(state.cartPrices.subtotal, this.subtotal)
          ) {
            this.subtotal = _.cloneDeep(state.cartPrices.subtotal);
            this.fixedDiscountMaxValue = getFixedCustomDiscountMaxValue(
              this.subtotal
            );
          }
        })
    );
  }

  clickCheckboxPromotion(promo) {
    if (promo && promo.custom_discount && promo.promoCheckbox) {
      this.setPromotionState(
        promo,
        initializeCustomDiscountPromotion(_.cloneDeep(promo))
      );
    }

    this.persistCheckboxPromotionsState();
  }

  changeCustomDiscountType(promo, discountType) {
    this.setPromotionState(
      promo,
      changeCustomDiscountPromotionType(_.cloneDeep(promo), discountType)
    );
    this.persistCheckboxPromotionsState();
  }

  selectCustomDiscountPreset(promo, value) {
    this.setPromotionState(
      promo,
      applyCustomDiscountPresetValue(_.cloneDeep(promo), value, this.subtotal)
    );
    this.persistCheckboxPromotionsState();
  }

  stepCustomDiscountValue(promo, direction) {
    this.setPromotionState(
      promo,
      stepCustomDiscountPromotionValue(
        _.cloneDeep(promo),
        direction,
        this.subtotal
      )
    );
    this.persistCheckboxPromotionsState();
  }

  updateCustomDiscountFixedValue(promo, value) {
    this.setPromotionState(
      promo,
      applyCustomDiscountPresetValue(_.cloneDeep(promo), value, this.subtotal)
    );
    this.persistCheckboxPromotionsState();
  }

  private persistCheckboxPromotionsState() {
    this.checkboxPromotions = normalizeCheckboxPromotions(
      this.checkboxPromotions
    );

    this.store.dispatch(
      new CheckboxPromotionsActions.SetCheckboxPromotions(
        _.cloneDeep(this.checkboxPromotions)
      )
    );
    persistCheckboxPromotions(this.checkboxPromotions);
  }

  async presentErrorToast(message, color) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: "middle",

      color: color,
      buttons: [
        {
          side: "end",
          icon: "assets/ionicons/close.svg",

          handler: () => {
            //console.log("Toast Closed");
          },
        },
      ],
    });
    toast.present();
  }

  trackbyFnc(index, item) {
    return item.promo_id;
  }

  private setPromotionState(promo, nextPromotionState) {
    const promotionIndex = _.findIndex(this.checkboxPromotions, {
      id: promo?.id,
    });

    if (promotionIndex !== -1) {
      this.checkboxPromotions[promotionIndex] = _.cloneDeep(nextPromotionState);
    }
  }

  ngOnDestroy() {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }
}
